import { Component, Vue, Watch } from 'vue-facing-decorator';
import gAuth from '@/config/googleAuth';

@Component
export default class GoogleApi extends Vue {
    _gAuthLoaded: boolean = false;

    get googleApiKey() {
        return `AIzaSyAriMGhbuma-dXNbZIR1lJm7em6qJBuwHM`;
    }

    get scriptId() {
        // @ts-ignore
        return `google-map-apis/${this.mapGetParam}`;
    }

    get isProd() {
        return process.env.NODE_ENV === 'production';
    }

    get clientId() {
        return process.env.VUE_APP_DEPLOY_TYPE === 'production' ? 'd04k88a39pgpuei34vcp9jonecqe0bvr' : '7pkj0n5blbmi64t7k8pbu4ck5b3d5nh7';
    }

    async addGoogleAuthModule() {
        if (!this._gAuthLoaded) {
            await gAuth.load({
                clientId: `536993715129-${this.clientId}.apps.googleusercontent.com`,
                scope: 'profile email https://www.googleapis.com/auth/calendar',
                prompt: 'select_account',
            });
            this._gAuthLoaded = true;
        }
    }

    onMountedCallback(callback: any) {
        // @ts-ignore
        if (typeof this.mountGoogleMaps === `function`) this.mountGoogleMaps();
        try {
            if (typeof callback === `function`) callback();
        } catch (e) {
            console.log(e);
        }
    }

    addGoogleMapsScript({ callback = () => {} }) {
        const script = document.createElement(`script`);
        script.type = `text/javascript`;
        // @ts-ignore
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.googleApiKey}&${this.mapGetParam}&language=${this.$i18n.locale}`;
        script.id = this.scriptId;
        script.async = true;
        script.onload = () => {
            this.onMountedCallback(callback);
        };
        document.head.appendChild(script);
    }

    removeGoogleMapScript() {
        const keywords = ['maps.googleapis'];
        // Remove google map scripts from DOM
        const scripts = document.head.getElementsByTagName('script');
        for (let i = scripts.length - 1; i >= 0; i--) {
            const scriptSource = scripts[i].getAttribute('src');
            if (scriptSource !== null) {
                if (keywords.filter(item => scriptSource.includes(item)).length) {
                    scripts[i].remove();
                }
            }
        }
        // @ts-ignore
        window.google = {};
    }

    mounted() {
        // @ts-ignore
        if (this.mapGetParam && this.mapsApi_isGoogleMap) {
            this.removeGoogleMapScript();
            this.addGoogleMapsScript({});
        // @ts-ignore
        } else if (this.mapsApi_isLeafletMap) {
            this.onMountedCallback({});
        }
    }

    beforeDestroy(): void {
        this.removeGoogleMapScript();
    }

    @Watch(`$route`)
    onSearchTextChange() {
        this.removeGoogleMapScript();
    }
};
